import { render, staticRenderFns } from "./ListDokumentasiCard.vue?vue&type=template&id=cbac0f10&scoped=true"
import script from "./ListDokumentasiCard.vue?vue&type=script&lang=js"
export * from "./ListDokumentasiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbac0f10",
  null
  
)

export default component.exports